"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const separateByCapitals_1 = require("../../../../app/shared/utils/separateByCapitals");
const useBanorte_1 = require("../../../../hooks/useBanorte");
const useUrl_1 = require("../../../../hooks/useUrl");
const calculation_service_1 = require("../../../../services/calculation.service");
const useBanorteStore_1 = require("../../../../stores/useBanorteStore");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
const loading_modal_vue_1 = __importDefault(require("../../../organisms/loading-modal.vue"));
const leading_step_vue_1 = __importDefault(require("../atoms/leading-step.vue"));
const insurance_card_vue_1 = __importDefault(require("../molecules/insurance-card.vue"));
const type_warranty_field_vue_1 = __importDefault(require("../molecules/type-warranty-field.vue"));
const axios_1 = __importDefault(require("../../../../app/shared/lib/axios"));
const modal_vue_1 = __importDefault(require("../../../../components/organisms/modal.vue"));
const SessionRepository_1 = __importDefault(require("../../../../repositories/SessionRepository"));
const useSessionStore_1 = require("../../../../stores/useSessionStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'step-banorte',
    props: {
        changeWarranty: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const sessionStore = (0, useSessionStore_1.useSessionStore)();
        const banorteStore = (0, useBanorteStore_1.useBanorteStore)();
        const { createCotizationUrl, createPreAutorizacionURL } = (0, useUrl_1.useUrl)();
        const coverageModal = (0, vue_2.ref)(false);
        const advertismentModal = (0, vue_2.ref)(false);
        const step = (0, vue_2.ref)(1);
        const downloading = (0, vue_2.ref)(false);
        const insurerType = (0, vue_2.ref)("Completo");
        const error = (0, vue_2.reactive)({
            active: false,
            message: "",
        });
        const stepBanorte = (0, vue_2.ref)(null);
        const modalCredit = (0, vue_2.ref)(null);
        const form = (0, vue_2.reactive)({
            stateId: null,
            warrantyId: null,
            warrantyType: "",
            warrantyExtended: true,
            acceptedTerms: false,
            acceptedInformation: false,
        });
        const coveragesName = (0, vue_2.reactive)({
            Completo: "Complete",
            Total: "Total",
            "Información no disponible": "Basica",
        });
        const coverages = (0, vue_2.reactive)({
            Completo: {
                vr: "Hasta 2 años VR",
                materialDamage: 3,
                roboTotal: 5,
                roboParcial: "Amparado",
                gastosTransportePp: "Amparado",
                gastosTransportePt: "Amparado",
            },
            Total: {
                vr: "Hasta 2 años VR",
                materialDamage: 5,
                roboTotal: 10,
                roboParcial: "Amparado",
                gastosTransportePp: "Amparado",
                gastosTransportePt: "Amparado",
            },
            "Información no disponible": {
                vr: "VR 1 año",
                materialDamage: 5,
                roboTotal: 10,
                roboParcial: "No Aplica",
                gastosTransportePp: "No Aplica",
                gastosTransportePt: "No Aplica",
            },
        });
        const assuranceList = (0, vue_2.ref)();
        const handleStateField = (stateId) => (form.stateId = stateId);
        const handleTypeWarrantyField = (warrantyId) => {
            const type_insurance_payment = [
                'Financiado',
                'Multianual Financiado',
                'Contado',
                'Multianual Contado'
            ];
            form.warrantyId = warrantyId;
            banorteStore.warrantyType = type_insurance_payment[warrantyId - 1];
        };
        const handleInsurance = (insurer) => {
            step.value = 3;
            let listTickets = null;
            banorteStore.insurer = insurer;
            if (form.warrantyId) {
                if (banorteStore?.insurer?.listaRecibos != undefined) {
                    listTickets = banorteStore?.insurer?.listaRecibos?.map(recibo => recibo?.primaTotal ?? "0.00");
                }
                fetch({
                    enganchePercentage: banorteStore.enganchePercentage,
                    enganche: banorteStore.engancheAmount,
                    plazo: store.plazo,
                    powerTrain: store.powerTrain,
                    subsidiary: store.distributor,
                    tipoSeguro: form.warrantyId,
                    entidadFederativa: store.state.id,
                    importeCatSegDanio: Number(banorteStore?.insurer?.listaRecibos?.[0].primaTotal) ?? 0,
                    garantia_extendida: banorteStore?.extendedWarranty?.include ?? false,
                    pago_garantia: banorteStore?.extendedWarranty?.payment ?? 'Financiado',
                    listaImporteSeguroDano: listTickets
                }).then((response) => {
                    banorteStore.data = response;
                    step.value = 4;
                }).catch(() => {
                    step.value = 3;
                });
            }
        };
        const createPDF = async () => {
            try {
                downloading.value = true;
                const url = `/quotation/download/banorte/${store.uuid}`;
                const blobData = await axios_1.default.get(url, { responseType: "blob" });
                const href = URL.createObjectURL(blobData.data);
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "Amortizacion-Banorte.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            }
            catch (e) {
                error.active = true;
                error.message = "Se produjo un error durante la generación del PDF; por favor, inténtalo de nuevo.";
            }
            finally {
                downloading.value = false;
            }
        };
        const { fetch, isLoading } = (0, useBanorte_1.useBanorte)();
        (0, vue_2.watch)(() => [form.warrantyId], () => {
            if (form.warrantyId) {
                fetch({
                    enganchePercentage: banorteStore.enganchePercentage,
                    enganche: banorteStore.engancheAmount,
                    plazo: store.plazo,
                    powerTrain: store.powerTrain,
                    subsidiary: store.distributor,
                    tipoSeguro: form.warrantyId,
                    entidadFederativa: store.state.id,
                    importeCatSegDanio: null,
                    garantia_extendida: banorteStore?.extendedWarranty?.include ?? false,
                    pago_garantia: banorteStore?.extendedWarranty?.payment ?? 'Financiado',
                    listaImporteSeguroDano: null
                }).then((response) => {
                    banorteStore.data = response;
                    if (banorteStore.insurer == null || banorteStore.data?.resultado?.listaSeguroAuto?.length != 0) {
                        assuranceList.value = banorteStore?.data?.resultado?.listaSeguroAuto;
                    }
                    step.value = 3;
                });
            }
        });
        (0, vue_2.watch)(() => [step.value], () => {
            if (step.value != 4) {
                return;
            }
            let listTickets = ["0.00"];
            if (banorteStore?.insurer?.listaRecibos != undefined) {
                listTickets = banorteStore?.insurer?.listaRecibos?.map(recibo => recibo?.primaTotal ?? "0.00");
            }
            SessionRepository_1.default.addBanorteToSession(store.uuid, {
                cat: Number(banorteStore.data?.resultado?.cat),
                enganche: store.enganche,
                cobertura_seguro: banorteStore.insurer?.descPaquete,
                financiamiento: (0, calculation_service_1.calculateMontoSolicitado)(store.powerTrain?.price, banorteStore.engancheAmount),
                financiera: "Banorte",
                mensualidad: Number(banorteStore.data?.resultado?.pagoMensual),
                mensualidad_seguro: Number(banorteStore.insurer?.primaTotal) / store.plazo,
                plazo: store.plazo,
                tasa_interes_fija: Number(banorteStore.data?.resultado?.tasa),
                tipo_cotizacion: "financiamiento",
                tipo_pago_seguro: banorteStore.warrantyType,
                total_pagar: Number(banorteStore.data?.resultado?.totalPagar),
                aseguradora: {
                    id: banorteStore.insurer?.idAseguradora,
                    nombre: banorteStore.insurer?.aseguradora,
                    paquete: banorteStore.insurer?.paquete,
                },
                distribuidor: {
                    id: store.distributor?.id,
                },
                importe_cat_seguro_danio: banorteStore.data?.resultado?.importeCatSegDanio,
                importe_cat_seguro_vida: banorteStore.data?.resultado?.importeCatSegVida,
                vehicle: {
                    exterior_color_id: store.exteriorColor?.id,
                    interior_color_id: store.interiorColor?.id,
                    power_train_id: store.powerTrain?.id,
                },
                garantia_extendida: {
                    agregar: banorteStore?.extendedWarranty?.include,
                    tipo_pago_garantia: banorteStore?.extendedWarranty?.payment
                },
                listaImporteSeguroDano: listTickets
            })
                .then((response) => {
                sessionStore.id = response.id;
            })
                .catch((error) => {
                console.error(error);
            });
        });
        (0, vue_2.watch)(() => [advertismentModal.value], () => {
            if (advertismentModal.value) {
                modalCredit.value?.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        });
        (0, vue_2.watch)(() => props.changeWarranty, () => {
            form.warrantyId = null;
            banorteStore.warrantyType = '';
            step.value = 1;
        });
        const pagoMensual = (0, vue_2.computed)(() => {
            const pagoMensual = +banorteStore.data?.resultado?.pagoMensual ?? 0;
            const primaTotal = +banorteStore.insurer?.primaTotal ?? 0;
            const plazo = store.plazo;
            return pagoMensual + primaTotal / plazo;
        });
        const montoSolicitado = (0, vue_2.computed)(() => {
            return (0, calculation_service_1.calculateMontoSolicitado)(store.powerTrain?.price, banorteStore.engancheAmount);
        });
        const generateCotizationUrl = (hasTable) => {
            return (createCotizationUrl({
                isIframe: store.iframe,
                webpage: store.distributor?.webpage,
                uuid: store.uuid,
                hasTable,
            }) ?? "#");
        };
        const generatePreAuthorizationUrl = () => {
            return (createPreAutorizacionURL({
                webpage: store.distributor?.webpage,
                uuid: store.uuid,
                iframe: store.iframe,
            }) ?? "#");
        };
        const insurers = (0, vue_2.computed)(() => {
            if (banorteStore.insurer == null || banorteStore.data?.resultado?.listaSeguroAuto?.length == 0) {
                return banorteStore.data?.resultado?.listaSeguroAuto?.filter((item) => item.descPaquete === insurerType.value);
            }
            else {
                return assuranceList.value?.filter((item) => item.descPaquete === insurerType.value);
            }
        });
        (0, vue_2.onMounted)(() => {
            stepBanorte.value?.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return { __sfc: true, store, sessionStore, banorteStore, createCotizationUrl, createPreAutorizacionURL, coverageModal, advertismentModal, step, downloading, insurerType, error, stepBanorte, modalCredit, form, coveragesName, coverages, assuranceList, props, handleStateField, handleTypeWarrantyField, handleInsurance, createPDF, fetch, isLoading, pagoMensual, montoSolicitado, generateCotizationUrl, generatePreAuthorizationUrl, insurers, separateByCapitals: separateByCapitals_1.separateByCapitals, LoadingModal: loading_modal_vue_1.default, LeadingStep: leading_step_vue_1.default, InsuranceCard: insurance_card_vue_1.default, TypeWarrantyField: type_warranty_field_vue_1.default, Modal: modal_vue_1.default };
    }
});
